import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { COLON } from "../../../../constants";


export default function ColonAddOnCard() {
  

return (

    <CardImageMarkers 
    
        image={COLON}
        title="Colon Cancer Prevention - IFOB"
        subtitle="Non-invasive stool test for early detection of blood in the stool to support colon cancer prevention"

        markersTitle="19,- incl. VAT"
        markers="Immunochemical Fecal Occult Blood (iFOB) Test"

    />


)
}